import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAllActiveSettings } from "./home.service";
import { IHomeState } from "./homeModel";

const initialState: IHomeState = {
  loading: false,
  error: "",
  SettingList: [],
};

const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllActiveSettings.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllActiveSettings.fulfilled, (state, action) => {
      state.loading = false;
      state.SettingList = action.payload;
      state.error = "";
    });
    builder.addCase(getAllActiveSettings.rejected, (state, action) => {
      state.loading = false;
      state.SettingList = initialState.SettingList;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

// export const {
//   setDiscountID,
//   clearDiscountID,
//   clearDiscountDetails,
//   openDrawer,
//   closeDrawer,
//   openDeleteModal,
//   closeDeleteModal,
// } = homeSlice.actions;
export default homeSlice.reducer;
